import tw, { styled } from 'twin.macro'

// Hero gradient: the "two-tone mesh" (emerald top-left, gold bottom-right) over charcoal.
const HERO_GRADIENT = `radial-gradient(circle at 15% 18%, rgba(65,205,127,0.24), transparent 42%),
  radial-gradient(circle at 85% 85%, rgba(255,196,37,0.18), transparent 42%),
  linear-gradient(180deg, #0e120f 0%, #14181a 100%)`

export const ScreenWrapper = styled.div`
  ${tw`flex flex-col bg-charcoal-900 text-white`}
`

export const Hero = styled.section`
  ${tw`flex flex-col items-center text-center gap-6 px-6 md:px-16 pt-28 pb-20 lg:pt-36`}
  background-image: ${HERO_GRADIENT};

  > h1 {
    ${tw`text-6xl lg:text-8xl font-serif text-gold-500`}
  }

  > p {
    ${tw`text-xl md:text-2xl max-w-2xl text-charcoal-200`}
  }
`

export const Mark = styled.img`
  ${tw`w-[150px] h-auto`}
`

export const Section = styled.section`
  ${tw`px-6 md:px-16 py-20 border-t border-charcoal-700`}

  > h2 {
    ${tw`text-3xl lg:text-4xl font-serif text-gold-500 pb-6`}
  }

  > p {
    ${tw`text-lg md:text-xl max-w-2xl text-charcoal-200`}
  }
`

// "What is AVIT?" two-column layout: explainer body (left) + whitepaper callout card (right).
export const Split = styled.div`
  ${tw`flex flex-col md:flex-row md:items-start gap-8 md:gap-12`}
`

export const SplitMain = styled.div`
  ${tw`flex-1`}

  > p {
    ${tw`text-lg md:text-xl text-charcoal-200`}
  }
`

export const Aside = styled.div`
  ${tw`w-full md:w-80 shrink-0 bg-charcoal-800 border border-charcoal-600 rounded-md p-6`}

  > h3 {
    ${tw`text-xl font-serif text-gold-500 pb-2`}
  }

  > p {
    ${tw`text-base text-charcoal-200`}
  }
`

export const CtaLink = styled.a`
  ${tw`inline-block mt-6 bg-gold-500 text-black uppercase tracking-widest rounded-md border-2 border-gold-500 px-6 py-3 hover:bg-gold-300 hover:border-gold-300 transition-colors`}
`

export const ContractLink = styled.a`
  ${tw`block mt-6 text-lg text-emerald-500 underline break-words`}
`

export const MetricsGrid = styled.div`
  ${tw`grid grid-cols-1 sm:grid-cols-3 gap-4 max-w-3xl mt-6`}
`

export const Metric = styled.div`
  ${tw`bg-charcoal-800 border border-charcoal-600 rounded-md p-6`}
`

export const MetricValue = styled.div`
  ${tw`text-3xl lg:text-4xl font-serif text-gold-500`}
`

export const MetricLabel = styled.div`
  ${tw`text-sm uppercase tracking-widest text-charcoal-400 mt-2`}
`

export const AsOf = styled.p`
  ${tw`italic text-xs mt-4`}
  color: #979797 !important;
`

// AVIT terms notice. Body text is the verbatim Cleary-cleared language; the inline
// link points to the production AvitToken proxy on Blockscout.
export const Terms = styled.section`
  ${tw`px-6 md:px-16 py-12 border-t border-charcoal-700 text-sm text-charcoal-400`}

  > h2 {
    ${tw`text-3xl lg:text-4xl font-serif text-gold-500 pb-6`}
  }

  > p {
    ${tw`max-w-3xl leading-relaxed`}
  }

  a {
    ${tw`text-emerald-500 underline break-all`}
  }
`
